/**
 * The compare-mode key. It moved out of the diff column and into zone 2 of the
 * bar on desktop. Phones reserve that space for document save feedback.
 */
export default function DiffLegend() {
  return (
    <span className="hidden md:inline-flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.12em] text-faint">
      <span className="inline-flex items-center gap-1.5">
        <span aria-hidden className="w-3 h-2 rounded-sm bg-success/30 border border-success" />
        Inserted
      </span>
      <span className="inline-flex items-center gap-1.5">
        <span aria-hidden className="w-3 h-2 rounded-sm bg-error/25 border border-error" />
        Removed
      </span>
    </span>
  );
}
